import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTema } from '@/lib/tema';

/**
 * Gerado por `npx shadcn add sonner` e adaptado: o original importa `useTheme` do `next-themes`
 * (este projeto não é Next) — aqui o tema vem do nosso `ContextoTema` (`src/lib/tema.ts`).
 */
const Toaster = ({ ...props }: ToasterProps) => {
  const { tema } = useTema();

  return (
    <Sonner
      theme={tema === 'escuro' ? 'dark' : 'light'}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
